import config from '@/config'

export default {
  user_status: {
    NEW: "Người dùng mới, nhưng chưa được xác minh",
    ACTIVE: "Người dùng hoạt động",
    RESET: "Mật khẩu người dùng đã được đặt lại",
    ATTEMPT_BLOCK: "Người dùng bị chặn do 3 lần đăng nhập không thành công",
    COMPANY_BLOCK: "Người dùng bị chặn bởi công ty",
    SUSPEND: "Người dùng bị đình chỉ"
  },

  login: "Đăng nhập vào tài khoản của bạn",
  relogin: "Vui lòng đăng nhập lại vào tài khoản của bạn.",
  expired: "Phiên đã hết hạn!",
  denied: "Không có quyền truy cập!",
  success: "THÀNH CÔNG",
  search_by_id: "Tìm kiếm theo ID",
  search_by_full_id: "Tìm kiếm theo ID đầy đủ",
  successful_change_password: "Bạn đã thay đổi mật khẩu thành công.",
  select_option: "Chọn tùy chọn của bạn",
  no_data_available: "Không có dữ liệu nào",
  no_rating_available: "Không có đánh giá nào",
  successful_update_security: "Bạn đã cập nhật bảo mật thành công.",
  successful_disable_security: "Bạn đã vô hiệu hóa bảo mật thành công.",
  update_security_confirm: "Bạn có chắc chắn muốn cập nhật bảo mật không?",
  disable_security_confirm: "Bạn có chắc chắn muốn vô hiệu hóa bảo mật không?",
  change_operator_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái của nhà điều hành \"{name}\" không?",
  change_member_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái của thành viên \"{name}\" không?",
  change_bank_account_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái tài khoản \"{name}\" không?",
  change_promotion_seq_confirm: "Bạn có chắc chắn muốn thay đổi thứ tự \"{id}\" không?",
  change_promo_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái khuyến mãi của \"{name}\" không?",
  change_promo_signup_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái đăng ký khuyến mãi của \"{name}\" không?",
  successful_update_account_setup: "Bạn đã cập nhật thiết lập tài khoản thành công.",
  unblock_member_confirm: "Bạn có chắc chắn muốn bỏ chặn thành viên \"{name}\" không?",
  unblock_operator_confirm: "Bạn có chắc chắn muốn bỏ chặn nhà điều hành \"{name}\" không?",
  block_sub_account_confirm: "Bạn có chắc chắn muốn chặn tài khoản phụ \"{name}\" không?",
  unblock_sub_account_confirm: "Bạn có chắc chắn muốn bỏ chặn tài khoản phụ \"{name}\" không?",
  successful_create_secondary_account: "Bạn đã tạo tài khoản phụ thành công.",
  successful_update_account_password: "Bạn đã cập nhật mật khẩu tài khoản thành công.",
  update_account_password_cancel: "Bạn có chắc chắn muốn hủy cập nhật mật khẩu tài khoản không?",
  change_affiliate_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái của đối tác \"{name}\" không?",
  unblock_affiliate_confirm: "Bạn có chắc chắn muốn bỏ chặn đối tác \"{name}\" không?",
  change_coupon_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái của phiếu giảm giá \"{name}\" không?",
  submit_acknowledgement_confirm: "Bạn có chắc chắn muốn gửi xác nhận không?",
  change_bank_group_default_confirm: "Bạn có chắc chắn muốn đặt \"{name}\" làm nhóm ngân hàng mặc định không?",
  change_withdrawal_limit_default_confirm: "Bạn có chắc chắn muốn đặt \"{name}\" làm giới hạn rút tiền mặc định không?",
  change_promotion_group_default_confirm: "”Bạn có chắc chắn muốn đặt \"{name}\" làm nhóm khuyến mãi mặc định không?",
  change_referral_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái giới thiệu của \"{name}\" không?",
  change_withdrawal_limit_confirm: "Bạn có chắc chắn muốn thay đổi giới hạn rút tiền của \"{name}\" không?",
  change_promotion_group_confirm: "Bạn có chắc chắn muốn thay đổi nhóm khuyến mãi của \"{name}\" không?",
  change_bank_group_confirm: "Bạn có chắc chắn muốn thay đổi nhóm ngân hàng của \"{name}\" không?",
  change_member_bet_limit_confirm: "Bạn có chắc chắn muốn thay đổi giới hạn cược của \"{name}\" \"{provider}\" không?",
  assign_free_credit_confirm: "Bạn có chắc chắn muốn cấp tín dụng miễn phí cho \"{name}\" không?",
  update_survey_status_confirm: "Bạn có chắc chắn muốn cập nhật trạng thái khảo sát không?",
  move_banner_up_confirm: "Bạn có chắc chắn muốn di chuyển banner \"{name}\" lên không?",
  move_banner_down_confirm: "Bạn có chắc chắn muốn di chuyển banner \"{name}\" xuống không?",
  delete_banner_confirm: "Bạn có chắc chắn muốn xóa banner \"{name}\" không?",
  change_banner_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái của banner \"{name}\" không?",
  delete_page_confirm: "Bạn có chắc chắn muốn xóa trang \"{name}\" không?",
  change_page_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái trang \"{name}\" không?",
  clear_maintenance_time_confirm: "Bạn có chắc chắn muốn xóa thời gian bảo trì của \"{name}\" không?",
  successful_clear_outstanding: "Bạn đã xóa thành công số dư {amt}.",
  clear_outstanding_confirm: "Bạn có chắc chắn muốn xóa số dư của \"{name}\" không?",
  trace_outstanding_confirm: "Bạn có chắc chắn muốn theo dõi số dư của \"{name}\" không?",
  change_setting_confirm: "Bạn có chắc chắn muốn thay đổi cài đặt \"{name}\" không?",
  add_bonus_list_member_confirm: "Bạn có chắc chắn muốn thêm thành viên đã chọn vào danh sách thưởng không?",
  delete_bonus_list_member_confirm: "Bạn có chắc chắn muốn xóa thành viên đã chọn khỏi danh sách thưởng không?",
  delete_ip_address_confirm: "Bạn có chắc chắn muốn xóa ip \"{ip}\" dưới \"{name}\" không?",
  add_ip_address_confirm: "Bạn có chắc chắn muốn thêm ip \"{ip}\" dưới \"{name}\" không?",
  change_payment_mode_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái phương thức thanh toán của \"{name}\" không?",
  change_provider_group_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái của \"{group}\" dưới \"{mode}\" không?",
  bulk_issue_bonus_member_confirm: "Bạn có chắc chắn muốn phát thưởng cho các thành viên trong danh sách thưởng không?",
  change_provider_group_recommend_confirm: "Bạn có chắc chắn muốn thay đổi gợi ý của \"{group}\" dưới \"{mode}\" không?",
  change_provider_group_seq_confirm: "Bạn có chắc chắn muốn thay đổi thứ tự của \"{group}\" dưới \"{mode}\" không?",
  no_member_found: "Không tìm thấy thành viên nào",
  redeposit_ticket_confirm: "Bạn có chắc chắn muốn nạp lại vé không?",
  change_provider_group_limit_confirm: "Bạn có chắc chắn muốn thay đổi giới hạn \"{group}\" dưới \"{mode}\" không?",
  audit_ticket_confirm: "Bạn có chắc chắn muốn kiểm tra vé không?",
  review_ticket_confirm: "Bạn có chắc chắn muốn xem lại vé không?",
  change_promotion_group_seq_confirm: "Bạn có chắc chắn muốn thay đổi thứ tự \"{promotion}\" trong \"{group}\" không?",
  unlock_custom_vip_confirm: "Bạn có chắc chắn muốn mở khóa vip tùy chỉnh \"{name}\" không?",
  move_affiliate_confirm: "Bạn có chắc chắn muốn di chuyển toàn bộ nhánh của \"{name}\" trực tiếp dưới \"{operator}\" không?",
  cancel_unfinish_round_confirm: "Bạn có chắc chắn muốn hủy vòng \"{round}\" chưa hoàn thành không?",
  change_payment_mode_seq_confirm: "Bạn có chắc chắn muốn thay đổi thứ tự \"{mode}\" không?",
  remove_bank_default_provider_confirm: "Bạn có chắc chắn muốn xóa nhà cung cấp mặc định \"{bank}\" không?",
  change_label_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái nhãn \"{name}\" không?",
  clear_iframe_url_confirm: "Bạn có chắc chắn muốn xóa url iframe không?",
  delete_turnover_tier_confirm: "Bạn có chắc chắn muốn xóa cấp độ doanh thu \"{name}\" không?",
  vip_provider_rebate_batch_confirm: "Bạn có xác nhận tiến hành cập nhật lô hoàn tiền cho nhà cung cấp vip không?",
  copy_rebate_rate_all_confirm: "Bạn có chắc chắn muốn sao chép \"{name}\" của \"{provider}\" cho tất cả các nhà cung cấp không?",
  edit_vip_confirm: "Bạn có muốn cập nhật tỷ lệ hoàn tiền của \"{name}\" không?",
  add_promotion_custom_member_confirm: "Bạn có muốn thêm danh sách thành viên khuyến mãi tùy chỉnh không?",
  delete_promotion_custom_member_confirm: "Bạn có muốn xóa danh sách thành viên tùy chỉnh khuyến mãi \"{name}\" không?",
  change_rescue_fund_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái quỹ cứu trợ \"{name}\" không?",
  add_rescue_fund_custom_member_confirm: "Bạn có muốn thêm danh sách thành viên tùy chỉnh quỹ cứu trợ không?",
  delete_rescue_fund_custom_member_confirm: "Bạn có muốn xóa danh sách thành viên tùy chỉnh quỹ cứu trợ \"{name}\" không?",
  change_ads_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái quảng cáo của \"{name}\" không?",
  adjust_amount_bank_tooltip: "Hỗ trợ dấu trừ (-) để trừ số dư từ số dư tài khoản ngân hàng",
  adjust_amount_operator_tooltip: "Hỗ trợ dấu trừ (-) để trừ số dư từ ví của nhà điều hành",
  adjust_amount_member_tooltip: "Hỗ trợ dấu trừ (-) để trừ số dư từ số dư của thành viên",
  purchase_domain_tooltips: "Chúc mừng!! Chúc bạn sẽ thực hiện được ước mơ của mình!",
  change_provider_game_seq_confirm: "Bạn có chắc chắn muốn thay đổi thứ tự \"{mode}\" không?",
  purchase_domain_confirm: "Bạn có chắc chắn muốn mua miền \"{name}\" không?",
  search_by_domain_name: "Tìm kiếm theo Tên miền",
  search_by_domain_status: "Tìm kiếm theo Trạng thái miền",
  search_by_account_id: "Tìm kiếm theo ID Tài khoản",
  search_by_operator_id: "Tìm kiếm theo ID người điều hành",
  search_by_full_name: "Tìm kiếm theo Họ và Tên",
  search_by_contact_phone: "Tìm kiếm theo Số điện thoại liên hệ",
  search_by_signup_ip: "Tìm kiếm theo IP Đăng ký",
  search_by_referral_code: "Tìm kiếm theo Mã giới thiệu",
  search_by_bank_acc_no: "Tìm kiếm theo Số tài khoản Ngân hàng",
  search_by_affiliate_code: "Tìm kiếm theo Mã liên kết",
  info1: "1. Không cho phép subdomain",
  info2: "2. Không yêu cầu 'https://' hoặc 'http://'",
  info3: "3. Ví dụ: abc.com",
  move_announcement_banner: "Sắp xếp lại banner",
  atLeastOneChecked: "Ít nhất một ngưỡng cần được kiểm tra",
  adjustWalletTooltips: "Hỗ trợ dấu trừ (-) để trừ số dư từ ví liên kết",
  emailOTPTooltips: "Mã OTP qua email sẽ hết hạn sau 3 phút kể từ khi yêu cầu",
  domain_status_update_confirm: "Bạn có muốn cập nhật trạng thái của \"{name}\" không?",
  delete_access_control_confirm: "Bạn có chắc chắn muốn xóa \"{name}\" không?",
  delete_access_control_success: "Bạn đã xóa \"{name}\" thành công.",
  add_access_control_confirm: "Bạn có chắc chắn muốn thêm kiểm soát truy cập không?",
  add_access_control_success: "Bạn đã thêm kiểm soát truy cập thành công.",
  delete_access_auto_confirm: "Bạn có chắc chắn muốn xóa \"{name}\"?",
  delete_access_auto_success: "Bạn đã xóa thành công \"{name}\".",
  add_access_auto_confirm: "Bạn có chắc chắn muốn thêm vào phân công tự động?",
  add_access_auto_success: "Bạn đã thêm thành công vào phân công tự động.",
  move_banner_confirm: "Bạn có chắc chắn muốn thay đổi \"{name}\" sang vị trí \"{position}\" không?",
  delete_game_exclude_confirm: "Bạn có chắc chắn muốn xóa \"{name}\" không?",
  banner_size_tooltips: "Vui lòng tuân theo kích thước hình ảnh cho phép: \"{size}\".",
  purchase_domain_success: "Mua miền thành công!",
  purchase_domain_failed: "Mua miền thất bại!",
  apply_domain_success: "Áp dụng miền thành công!",
  apply_domain_failed: "Áp dụng miền thất bại!",
  tooltips_pnl: "Platform winlose x Platform PT % = Tổng thu nhập",
  delete_package_confirm: "Bạn có chắc chắn muốn xóa gói \"{package}\" không?",
  search_by_lang_code: "Tìm kiếm theo mã ngôn ngữ",
  pleaseSelectAnImage: "Vui lòng chọn một hình ảnh",
  pleaseSelectAValidImageType: "Vui lòng chọn một loại hình ảnh hợp lệ",
  imageTooLargeMaxSizeAllowedIsOneMb: "Hình ảnh quá lớn, kích thước tối đa cho phép là 1MB",
  uploadYourLogoWithPngOrJpegFormat: "Tải lên logo của bạn với định dạng png hoặc jpeg",
  allowedPngAndJpegOnlyMaxOneMb: "Chỉ cho phép png và jpeg (Kích thước hình ảnh tối đa 1MB)",
  delete_theme_content_confirm: "Bạn có chắc chắn muốn xóa nội dung chủ đề \"{themecontent}\" không?",
  delete_theme_confirm: "Bạn có chắc chắn muốn xóa chủ đề \"{theme}\" không?",
  delete_color_confirm: "Bạn có chắc chắn muốn xóa màu \"{color}\" không?",
  delete_content_confirm: "Bạn có chắc chắn muốn xóa nội dung \"{content}\" không?",
  reset_password_confirm: "Bạn có chắc chắn muốn đặt lại mật khẩu cho \"{userid}\" không?",
  block_account_confirm: "Bạn có chắc chắn muốn chặn \"{userid}\" không?",
  suspend_account_confirm: "Bạn có chắc chắn muốn đình chỉ \"{userid}\" không?",
  active_account_confirm: "Bạn có chắc chắn muốn kích hoạt \"{userid}\" không?",
  temporaryPasswordFor: "Mật khẩu tạm thời cho \"{name}\" là ",
  needAiToGenerateLogo: "Cần AI để tạo logo",
  delete_domain_confirm: "Bạn có chắc chắn muốn xóa miền \"{domain}\" không?",
  previewImageForIllustrationOnly: "Hình ảnh xem trước chỉ mang tính minh họa.",
  actualResultMayVary: "Kết quả thực tế có thể khác do việc nâng cấp website.",
  chooseYourPreferedResponsiveLayoutTheme: "Chọn chủ đề bố cục phản hồi ưa thích của bạn",
  chooseYourPreferedColor: "Chọn màu sắc bạn thích",
  please_update_provider_before_edit_game: "Vui lòng cập nhật nhà cung cấp trước khi chỉnh sửa trò chơi",
  delete_theme_content_group_confirm: "Bạn có chắc chắn muốn xóa nhóm nội dung chủ đề \"{themecontentgroup}\" không?",
  phoneFormat: "ví dụ: +63XXXXXXXXXX",
  change_theme_will_replace_menu: "Bạn có chắc chắn muốn cập nhật chủ đề không? (Thay đổi giao diện sẽ làm Menu bị thay thế)",
  change_provider_seq_confirm: "Bạn có chắc chắn muốn thay đổi thứ tự của \"{provider}\" không?",
  change_provider_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái nhà cung cấp \"{provider}\" không?",
  actionPerformWillReflectProd: "* Mọi hành động thực hiện ở đây sẽ trực tiếp phản ánh lên Production",
  site_sync_confirm: "Bạn có chắc chắn muốn đồng bộ lên Production không?",
  clear_profile_setting_maintenance_confirm: "Bạn có chắc chắn muốn xóa bảo trì không?",
  change_social_platform_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái nền tảng xã hội của \"{name}\" không?",
  search_by_site_name: "Tìm kiếm theo tên trang web",
  change_social_account_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái tài khoản xã hội của \"{name}\" không?",
  themeMenuMessage1: "* Sắp xếp lại thứ tự menu bằng cách kéo và thả mục menu",
  themeMenuMessage2: "* Bỏ chọn hộp kiểm nếu muốn ẩn mục menu",
  search_by_operator: "Tìm kiếm theo Nhà điều hành",
  search_by_ticket: "Tìm kiếm theo Vé",
  search_member: "Tìm kiếm Thành viên",
  site_recreate_confirm: "Bạn có chắc chắn muốn tái tạo trang web \"{name}\" không?",
  search_by_game_type: "Tìm kiếm theo Loại trò chơi",
  total_not_count_by_date_range: " Tổng này không được tính theo khoảng thời gian.",
  tooltips_upload_size: " Kích thước tệp đã tải lên không được vượt quá 1mb.",
  tooltips_href: " Trường Href yêu cầu phần mở rộng của miền. Ví dụ: 'yourwebsite.com/promotions', chỉ cần điền 'promotions' là đủ.",
  d_winlose_chart: "Trực quan hóa xu hướng thắng/thua và rút tiền.",
  d_turnover_chart: "Phân tích xu hướng doanh thu và tiền gửi.",
  d_deposit: "Hiển thị số lượng tiền gửi và số thành viên duy nhất.",
  d_withdrawal: "Hiển thị tổng số giao dịch rút tiền.",
  d_active_player: "Tổng số cược và số lần đăng nhập duy nhất của người chơi.",
  d_winlose: "Hiển thị tổng số thắng/thua ròng.",
  d_turnover: "Tổng doanh thu tạo ra.",
  d_member: "Số lượng tất cả các thành viên đã đăng ký.",
  d_referee: "Tổng số người giới thiệu của người dùng.",
  d_verfied_signup: "Số lượng người dùng đã xác minh và người dùng mới đăng ký.",
  d_ftd: "Số lượng và số tiền của các khoản tiền gửi lần đầu.",
  d_top_winner: "Mã người chơi và tổng số tiền thắng.",
  d_top_loser: "Mã người chơi và tổng số tiền thua.",
  d_top_deposit: "Mã người chơi và tổng số tiền gửi từ nhiều nhất đến ít nhất.",
  d_top_withdrawal: "Mã người chơi và tổng số tiền rút từ nhiều nhất đến ít nhất.",
  d_top_promotion: "Hạng, ID khuyến mãi, tên, và yêu cầu của người chơi.",
  d_payment_gateway: "Hạng, phương thức, nhà cung cấp, đã xử lý, bị từ chối, tổng số, và tỷ lệ thành công qua các cổng.",
  tooltips_promo_member_custom: "Vui lòng nhập nhiều ID thành viên với dấu phẩy phân cách. Ví dụ: member001,member002,member003",
  tooltips_social_facebook: "Ví dụ: https://www.facebook.com/",
  tooltips_social_instagram: "Ví dụ: https://www.instagram.com/",
  tooltips_social_skype: "Ví dụ: skype:<username>?chat",
  tooltips_social_telegram: "Ví dụ: https://t.me/<ID>",
  tooltips_social_tiktok: "Ví dụ: https://www.tiktok.com/<ID>",
  tooltips_social_wechat: "Ví dụ: <ID>",
  tooltips_social_whatsapp: "Ví dụ: https://wa.me/<ID>",
  tooltips_social_youtube: "Ví dụ: https://www.youtube.com/<ID>",
  search_by_business_id: "Tìm kiếm theo ID doanh nghiệp",
  ticket_taken_confirm: "Bạn có chắc chắn muốn kiểm soát trên ID vé này \"{name}\"?",
  tooltips_payment_setting: "Dưới đây chỉ được phản ánh nếu 'Cài đặt' - 'Cài đặt Thanh toán' được đặt thành 'RIÊNG'",
  tooltips_cms_announcement_main: "Tối đa 5 banner thông báo để có trải nghiệm người dùng tốt nhất",
  tooltips_cms_announcement_title: "Tối đa 30 ký tự để có trải nghiệm người dùng tốt nhất",
  tooltips_cms_announcement_body: "Tối đa 200 ký tự để có trải nghiệm người dùng tốt nhất",
  delete_livechat_confirm: "Bạn có chắc chắn muốn xóa trò chuyện trực tiếp không?",
  tooltips_vip_name: "Tối đa 10 ký tự để có trải nghiệm người dùng tốt nhất",

  choosePackage: "Chọn Gói",
  effortlessCreate: "Dễ dàng tạo, tối ưu hóa và quản lý trang web của bạn!",
  raiseNewHeight: "Nâng bạn lên một tầm cao mới",
  fastSecureStable: "Nhanh chóng, An toàn và Ổn định",
  realTimeData: "Thông tin chi tiết dữ liệu theo thời gian thực",
  highLevelTechTeam: "Đội ngũ kỹ thuật trình độ cao!",
  strategicEmpowerment: "Trao quyền chiến lược!",
  supportFirst: "Hỗ trợ 24/7 đặt bạn lên hàng đầu với các giải pháp cá nhân hóa!",
  empowermentBusiness: "Trao quyền thông qua gói Điều hành để đạt được mục tiêu kinh doanh!",
  pleaseFillUpSiteDetails: "Vui lòng điền thông tin chi tiết trang web của bạn",
  reviewYourOptionsAndCheckout: "Xem lại các tùy chọn của bạn và tiếp tục thanh toán",
  chooseYourPreferedResponsiveLayoutTheme: "Chọn giao diện bố cục đáp ứng mà bạn thích",
  chooseYourPreferedColor: "Chọn màu sắc bạn thích",
  pleaseSelectTheme: "Vui lòng chọn giao diện",
  pleaseSelectColor: "Vui lòng chọn màu",
  websiteLayoutAndThemeDesign: "Thiết kế Bố cục và Giao diện Trang web",
  operatorAccCreatedSuccessful: "Tài khoản Quản trị viên được tạo thành công",
  delete_default_template_confirm: "Bạn có chắc chắn muốn xóa mẫu trò chơi nhỏ \"{template}\" không?",
  search_by_template_code: "Tìm kiếm theo Mã Mẫu",
  delete_mini_game_confirm: "Bạn có chắc chắn muốn xóa trò chơi nhỏ \"{minigame}\" không?",
  delete_mini_game_template_confirm: "Bạn có chắc chắn muốn xóa mẫu trò chơi nhỏ \"{minigametemplate}\" không?",
  delete_reward_confirm: "Bạn có chắc chắn muốn xóa phần thưởng \"{reward}\" không?",
  search_by_game_name: "Tìm kiếm theo Tên Trò Chơi",
  tooltips_gamereward: "Giới hạn: {max}",
  change_gamify_status_confirm: "Bạn có chắc muốn thay đổi trạng thái phần thưởng của \"{gamify}\" không?",
  change_gamify_login_status_confirm: "Bạn có chắc muốn thay đổi trạng thái đăng nhập phần thưởng của \"{gamify}\" không?",
  change_gamify_daily_login_status_confirm: "Bạn có chắc muốn thay đổi trạng thái phần thưởng của Điểm danh hàng ngày (Đăng nhập hàng ngày) không?",
  change_partner_seq_confirm: "Bạn có chắc chắn muốn thay đổi thứ tự \"{id}\" không?",
  tooltips_partners_link: "Ví dụ: https://www.google.com/",
  delete_partner_confirm: "Bạn có chắc chắn muốn xóa đối tác \"{name}\" không?"
};
